interface ParagraphHeaderProps {
  children: string;
  className?: string;
  fontSize?: number;
  fontWeight?: number;
}

export const ParagraphHeader = ({
  children,
  className,
  fontSize = 20,
  fontWeight = 500,
}: ParagraphHeaderProps) => {
  return (
    <p
      className={`font-[${fontWeight}] text-[${fontSize}px] leading-[137%] ${className}`}
    >
      {children}
    </p>
  );
};
